import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {

  constructor() { }

  emailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const email = control.value;
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      const valid = emailPattern.test(email);

      return !valid ? { invalidEmail: true } : null;
    };
  }

  passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const password = control.value;
      const hasUpperCase = /[A-Z]/.test(password);
      const hasLowerCase = /[a-z]/.test(password);
      const hasNumeric = /[0-9]/.test(password);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
      const hasMinLength = password.length >= 8;

      const validationErrors: ValidationErrors = {};
      
      if (!hasUpperCase) validationErrors['noUpperCase'] = true;
      if (!hasLowerCase) validationErrors['noLowerCase'] = true;
      if (!hasNumeric) validationErrors['noNumber'] = true;
      if (!hasSpecialChar) validationErrors['noSpecialChar'] = true;
      if (!hasMinLength) validationErrors['minLength'] = true;
      
      const valid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecialChar && hasMinLength;

      return !valid ? { passwordStrength: true, ...validationErrors } : null;
    };
  }

  passwordMatchValidator(form: AbstractControl): ValidationErrors | null {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('repeatPassword')?.value;

    if (password && confirmPassword && password !== confirmPassword) {
      form.get('repeatPassword')?.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    }
    if (form.get('repeatPassword')?.hasError('passwordMismatch')) {
      const errors = { ...form.get('repeatPassword')?.errors };
      delete errors['passwordMismatch'];

      if (Object.keys(errors).length === 0) {
        form.get('repeatPassword')?.setErrors(null);
      } else {
        form.get('repeatPassword')?.setErrors(errors);
      }
    }

    return null;
  }

  numberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      
      const value = control.value;
      const isValid = !isNaN(Number(value)) && isFinite(Number(value));
      
      return !isValid ? { invalidNumber: true } : null;
    };
  }

}
